import { Box } from '@mui/material';
import { PropsWithChildren } from 'react';

const ACTIONS_SX = {
  mt: 1,
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 1,
} as const;

const InterruptionListCardActionsLayout = ({ children }: PropsWithChildren) => <Box sx={ACTIONS_SX}>{children}</Box>;

export default InterruptionListCardActionsLayout;
